<template>
  <div class="basic-block baika-shineki" :style="styles" id="baika-shineki">
    <div class="content-wrap">
      <img src="/static/img/recommend/lp/kurenotori/baikatitle.png" alt="あなたの３年後の姿" class="baika-shineki__title">
      <div class="baika-shineki__box">
        <img src="/static/img/recommend/lp/kurenotori/baika1.png" alt="sample" class="baika-shineki__sample">
        <lp-base-button
          label="<b>今と未来を占う</b>"
          design="fill"
          :color-scheme="colorScheme"
          @clicked="clickedSubscBtn('FortuneBaikaShineki')"
        />
      </div>
      <div class="baika-shineki__box">
        <img src="/static/img/recommend/lp/kurenotori/baika2.png" alt="sample" class="baika-shineki__sample">
        <lp-base-button
          label="<b>運命を知る</b>"
          design="fill"
          :color-scheme="colorScheme"
          @clicked="clickedSubscBtn('FortuneBaikaShinekiWord')"
        />
      </div>
    </div>
  </div>
</template>

<script>
import LpBaseButton from '@/utvStore/components/recommend/lp/partials/LpBaseButton'

export default {
  name: 'BlockBaikaShineki',
  components: {
    LpBaseButton,
  },
  props: {
    lpId: {
      type: Number,
      required: true,
    },
    colorScheme: {
      type: Object,
      required: true,
    },
    page: {
      type: String,
      default: '',
    },
    subscUrl: {
      type: String,
      default: '/'
    },
  },
  data() {
    return {
      params: {
        'FortuneBaikaShineki': {
          'event_category': `LP${this.lpId}${this.page}-subsc-button`,
          'event_label': 'baikashineki',
        },
        'FortuneBaikaShinekiWord': {
          'event_category': `LP${this.lpId}${this.page}-subsc-button`,
          'event_label': 'baikashinekiword',
        },
      }
    }
  },
  computed:{
    styles(){
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
      }
    }
  },
  methods: {
     clickedSubscBtn(data) {
      window.gtag('event', 'click', this.params[data])
      let url = this.subscUrl == '/' ? '/' : this.subscUrl
      location.href = this.$handoverParams(url)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../../../../sass/commons/commonVariables.scss";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);

.baika-shineki {
  padding: 60px 20px 60px;
  background: url('/static/img/recommend/lp/kurenotori/bg_baikashineki3.png') repeat 50% 0/375px auto;
  &__title {
    display: block;
    width: 289 / 375 * 100%;
    max-width: 289 * 1.3px;
    margin: 0 auto 23px;
  }
  &__box {
    max-width: 500px;
    margin: 0 auto 40px;
    background: #FFFFFF;
    border: 1px solid $l_col_keycolor;
    border-radius: 10px;
    padding: 16px 16px 24px;
    position: relative;
    &:last-of-type { margin-bottom: 0; }
    /*
    &::before {
      content: 'Sample';
      position: absolute;
      top: -0.6em;
      left: 0.9em;
      z-index: 1;
      font-weight: 600;
      font-size: Min(14 / 375 * 100vw, 14 * 1.3px);
      line-height: 1;
      color: $l_col_keycolor;
      text-shadow: 0 0 0.2em #fff, 0 0 0.2em #fff, 0 0 0.2em #fff, 0 0 0.2em #fff, 0 0 0.2em #fff, 0 0 0.2em #fff, 0 0 0.2em #fff, 0 0 0.2em #fff, 0 0 0.2em #fff;
    }
    */
  }
  &__sample {
    width: 100%;
    max-width: 420px;
    display: block;
    margin: 0 auto 24px;
  }
  .baseButton {
    max-width: 340px;
    margin: auto;
    /deep/ {
      .baseButton__button {
        padding: 14px 0;
        margin: 0 -15px;
        max-width: 300px;
      }
      b {
        font-size: 18px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/recommend/lp/counselor/kurenotori/blocks/BlockBaikaShineki.vue